import { ApiSliceParams } from "../interfaces";
import { makeBook } from "./book";
import { makeCompany } from "./company";
import { makePro } from "./pro";
import { makeSupplier } from "./supplier";
import { makeUser } from "./user";

export const makeSettings = (params: ApiSliceParams) => {
    const company = makeCompany(params);
    const pro = makePro(params);
    const user = makeUser(params);
    const supplier = makeSupplier(params);
    const book = makeBook(params);

    return {
        company,
        pro,
        user,
        book,
        supplier,
    };
};
